import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { toast } from "react-toastify";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import { convertThenFormat } from "../../common-data/Converts";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import { commonDeleteApi } from "../../../redux/reducers/deleteApiSlice";
import { plans_delete } from "../../../data/ApiEndpoints";

const CentralisedTabs = ({
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  setModValues,
  setSelectedTab,
  userInfoData,
  callFunction,
}) => {
  const dispatch = useDispatch();
  const {
    centralisedPlansLoading,
    centralisedPlansError,
    centralisedPlans,
    addonDrafts,
    addonDraftsLoading,
    addonDraftsError,
  } = useSelector((state) => state.plans);

  const iniPTDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniPTDatas);
  const [addonDatas, setAddonDatas] = useState(iniPTDatas);

  const handleTabSelect = (index) => {
    setIsPage(0);
    setSelectedTab(index);
  };

  const handleDelete = async (filter, rowData, type = "regular") => {
    if (filter?.uid) {
      const handleConfirm = async () => {
        try {
          const endpoint =
            type === "addon" ? "/addon/draft/delete" : "/plan/draft/V2/delete";

          const response = await dispatch(
            commonDeleteApi({
              TOKEN: userInfoData?.token,
              endpoint: endpoint,
              queryParams: filter,
            })
          ).unwrap();

          if (response?.status) {
            toast.success(response?.message || "Deleted successfully!");
            callFunction();
          } else {
            toast.error(response?.message || "Can not delete!");
          }
        } catch (error) {
          toast.error(error?.message || error || "Failed to delete");
        }
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure, you want to delete ${
          type === "addon"
            ? rowData?.addon_name || "this addon"
            : `${rowData?.plan_name || "this"} (${
                rowData?.duration || 0
              } Days) Plan`
        }!`
      );
    } else {
      toast.error("UID required!");
    }
  };

  useEffect(() => {
    if (
      !centralisedPlansLoading &&
      !centralisedPlansError &&
      centralisedPlans?.status &&
      centralisedPlans?.data?.length > 0
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: centralisedPlans.data,
        pagination:
          centralisedPlans?.pagination?.length > 0
            ? centralisedPlans.pagination
            : [],
      }));
    } else {
      setAllDatas(iniPTDatas);
    }
  }, [centralisedPlansLoading, centralisedPlansError, centralisedPlans]);

  useEffect(() => {
    if (
      !addonDraftsLoading &&
      !addonDraftsError &&
      addonDrafts?.status &&
      addonDrafts?.data?.length > 0
    ) {
      setAddonDatas((prevs) => ({
        ...prevs,
        allData: addonDrafts.data,
        pagination:
          addonDrafts?.pagination?.length > 0 ? addonDrafts.pagination : [],
      }));
    } else {
      setAddonDatas(iniPTDatas);
    }
  }, [addonDraftsLoading, addonDraftsError, addonDrafts]);

  const tbColumns = [
    {
      dataField: "uid",
      text: "plan name",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.plan_name || "NA"} ({row?.duration || 0} Days)
          </span>
        );
      },
    },
    {
      dataField: "category_name",
      text: "category",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.category_name || "NA"}</span>;
      },
    },
    {
      dataField: "price",
      text: "plan price",
      formatter: (_, row) => {
        return (
          <span className="tb-data">₹{convertThenFormat(row?.price || 0)}</span>
        );
      },
    },
    {
      dataField: "mapped_gyms",
      text: "Mapped Gyms",
      formatter: (_, row) => {
        const isMapped = Number(row?.mapped_gyms || 0) > 0;

        return (
          <span
            className={`tb-data ${isMapped ? "link" : ""}`}
            onClick={
              isMapped
                ? () =>
                    setModValues((prevs) => ({
                      ...prevs,
                      isModOpen: true,
                      modName: "mapped_gyms",
                      rowData: row,
                    }))
                : null
            }>
            {row?.mapped_gyms || "-"}
          </span>
        );
      },
    },
    {
      dataField: "view_details",
      text: "view details",
      formatter: (_, row) => (
        <div className="actionButtonContainer">
          <button
            account_type="button"
            className="actionBtn icon"
            disabled={false}
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "view_details",
                rowData: row,
              }))
            }>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-eye-fill"
              viewBox="0 0 16 16">
              <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
              <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
            </svg>
          </button>
        </div>
      ),
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (_, row) => (
        <div className="actionButtonContainer">
          <button
            type="button"
            className="actionBtn icon edit"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "edit",
                rowData: row,
              }))
            }>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none">
              <path
                d="M3.62891 17.3603V20.3254C3.62891 20.5985 3.84349 20.8131 4.1166 20.8131H7.08175C7.20855 20.8131 7.33535 20.7643 7.42313 20.6668L18.0743 10.0254L14.4166 6.36775L3.77521 17.0091C3.67768 17.1067 3.62891 17.2237 3.62891 17.3603ZM20.9029 7.19682C20.9933 7.10658 21.065 6.9994 21.114 6.88141C21.1629 6.76341 21.1881 6.63692 21.1881 6.50918C21.1881 6.38143 21.1629 6.25495 21.114 6.13695C21.065 6.01896 20.9933 5.91177 20.9029 5.82154L18.6205 3.53915C18.5302 3.44873 18.4231 3.37699 18.3051 3.32805C18.1871 3.2791 18.0606 3.25391 17.9328 3.25391C17.8051 3.25391 17.6786 3.2791 17.5606 3.32805C17.4426 3.37699 17.3354 3.44873 17.2452 3.53915L15.4603 5.32409L19.1179 8.98176L20.9029 7.19682Z"
                fill="url(#paint0_linear_14023_4477)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_14023_4477"
                  x1="3.62891"
                  y1="11.6344"
                  x2="21.1881"
                  y2="11.6344"
                  gradientUnits="userSpaceOnUse">
                  <stop offset="0.0447915" stopColor="#B4000B" />
                  <stop offset="1" stopColor="#DD0000" />
                </linearGradient>
              </defs>
            </svg>
          </button>
          <button
            type="button"
            account_type="button"
            className="actionBtn icon"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "map_plans",
                rowData: row,
              }))
            }>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-plus-circle-dotted"
              viewBox="0 0 16 16">
              <path d="M8 0q-.264 0-.523.017l.064.998a7 7 0 0 1 .918 0l.064-.998A8 8 0 0 0 8 0M6.44.152q-.52.104-1.012.27l.321.948q.43-.147.884-.237L6.44.153zm4.132.271a8 8 0 0 0-1.011-.27l-.194.98q.453.09.884.237zm1.873.925a8 8 0 0 0-.906-.524l-.443.896q.413.205.793.459zM4.46.824q-.471.233-.905.524l.556.83a7 7 0 0 1 .793-.458zM2.725 1.985q-.394.346-.74.74l.752.66q.303-.345.648-.648zm11.29.74a8 8 0 0 0-.74-.74l-.66.752q.346.303.648.648zm1.161 1.735a8 8 0 0 0-.524-.905l-.83.556q.254.38.458.793l.896-.443zM1.348 3.555q-.292.433-.524.906l.896.443q.205-.413.459-.793zM.423 5.428a8 8 0 0 0-.27 1.011l.98.194q.09-.453.237-.884zM15.848 6.44a8 8 0 0 0-.27-1.012l-.948.321q.147.43.237.884zM.017 7.477a8 8 0 0 0 0 1.046l.998-.064a7 7 0 0 1 0-.918zM16 8a8 8 0 0 0-.017-.523l-.998.064a7 7 0 0 1 0 .918l.998.064A8 8 0 0 0 16 8M.152 9.56q.104.52.27 1.012l.948-.321a7 7 0 0 1-.237-.884l-.98.194zm15.425 1.012q.168-.493.27-1.011l-.98-.194q-.09.453-.237.884zM.824 11.54a8 8 0 0 0 .524.905l.83-.556a7 7 0 0 1-.458-.793zm13.828.905q.292-.434.524-.906l-.896-.443q-.205.413-.459.793zm-12.667.83q.346.394.74.74l.66-.752a7 7 0 0 1-.648-.648zm11.29.74q.394-.346.74-.74l-.752-.66q-.302.346-.648.648zm-1.735 1.161q.471-.233.905-.524l-.556-.83a7 7 0 0 1-.793.458zm-7.985-.524q.434.292.906.524l.443-.896a7 7 0 0 1-.793-.459zm1.873.925q.493.168 1.011.27l.194-.98a7 7 0 0 1-.884-.237zm4.132.271a8 8 0 0 0 1.012-.27l-.321-.948a7 7 0 0 1-.884.237l.194.98zm-2.083.135a8 8 0 0 0 1.046 0l-.064-.998a7 7 0 0 1-.918 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3z" />
            </svg>
          </button>
          <button
            type="button"
            account_type="button"
            className="actionBtn icon"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "plan_features",
                rowData: row,
              }))
            }>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-text-paragraph"
              viewBox="0 0 16 16">
              <path
                fillRule="evenodd"
                d="M2 12.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5m0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5m4-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5"
              />
            </svg>
          </button>
          <button
            type="button"
            className="actionBtn icon delete"
            onClick={() => {
              const filters = {
                uid: row?.uid || "",
              };
              handleDelete(filters, row);
            }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill="none">
              <path
                d="M8.49846 4.3041H11.4978C11.4978 3.90637 11.3398 3.52492 11.0585 3.24369C10.7773 2.96245 10.3958 2.80445 9.99811 2.80445C9.60038 2.80445 9.21893 2.96245 8.9377 3.24369C8.65646 3.52492 8.49846 3.90637 8.49846 4.3041ZM7.4987 4.3041C7.4987 3.64121 7.76203 3.00548 8.23076 2.53675C8.69949 2.06802 9.33522 1.80469 9.99811 1.80469C10.661 1.80469 11.2967 2.06802 11.7655 2.53675C12.2342 3.00548 12.4975 3.64121 12.4975 4.3041H17.4963C17.6289 4.3041 17.7561 4.35676 17.8498 4.45051C17.9435 4.54425 17.9962 4.6714 17.9962 4.80398C17.9962 4.93655 17.9435 5.0637 17.8498 5.15745C17.7561 5.25119 17.6289 5.30386 17.4963 5.30386H16.4426L15.2489 15.6454C15.1645 16.3764 14.8143 17.0509 14.265 17.5405C13.7156 18.0302 13.0054 18.3007 12.2696 18.3008H7.72664C6.99077 18.3007 6.2806 18.0302 5.73125 17.5405C5.18191 17.0509 4.83173 16.3764 4.74735 15.6454L3.55363 5.30386H2.49988C2.3673 5.30386 2.24016 5.25119 2.14641 5.15745C2.05267 5.0637 2 4.93655 2 4.80398C2 4.6714 2.05267 4.54425 2.14641 4.45051C2.24016 4.35676 2.3673 4.3041 2.49988 4.3041H7.4987ZM8.99834 8.30315C8.99834 8.17057 8.94568 8.04343 8.85193 7.94968C8.75819 7.85593 8.63104 7.80327 8.49846 7.80327C8.36588 7.80327 8.23874 7.85593 8.14499 7.94968C8.05125 8.04343 7.99858 8.17057 7.99858 8.30315V14.3017C7.99858 14.4343 8.05125 14.5615 8.14499 14.6552C8.23874 14.7489 8.36588 14.8016 8.49846 14.8016C8.63104 14.8016 8.75819 14.7489 8.85193 14.6552C8.94568 14.5615 8.99834 14.4343 8.99834 14.3017V8.30315ZM11.4978 7.80327C11.3652 7.80327 11.238 7.85593 11.1443 7.94968C11.0505 8.04343 10.9979 8.17057 10.9979 8.30315V14.3017C10.9979 14.4343 11.0505 14.5615 11.1443 14.6552C11.238 14.7489 11.3652 14.8016 11.4978 14.8016C11.6303 14.8016 11.7575 14.7489 11.8512 14.6552C11.945 14.5615 11.9976 14.4343 11.9976 14.3017V8.30315C11.9976 8.17057 11.945 8.04343 11.8512 7.94968C11.7575 7.85593 11.6303 7.80327 11.4978 7.80327Z"
                fill="black"
              />
            </svg>
          </button>
        </div>
      ),
    },
  ];

  const addonTbColumns = [
    {
      dataField: "addon_name",
      text: "Plan Name",
      formatter: (_, row) => (
        <span className="tb-data">{row?.addon_name || "NA"}</span>
      ),
    },
    {
      dataField: "addon_for",
      text: "For",
      formatter: (_, row) => (
        <span className="tb-data">{row?.addon_for || "NA"}</span>
      ),
    },
    {
      dataField: "session_details",
      text: "Sessions",
      formatter: (_, row) => (
        <span className="tb-data">
          {row?.session_details?.length > 0
            ? `${row.session_details.length} packages`
            : "0"}
        </span>
      ),
    },
    {
      dataField: "intensity",
      text: "Intensity",
      formatter: (_, row) => (
        <span className="tb-data">{row?.intensity || "NA"}</span>
      ),
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius27 bold"
            style={{
              background: row?.status === "active" ? "#E2EFD5" : "#F3DADA",
              color: row?.status === "active" ? "#379C00" : "#D90000",
            }}>
            {row?.status || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "view_details",
      text: "view details",
      formatter: (_, row) => (
        <div className="actionButtonContainer">
          <button
            account_type="button"
            className="actionBtn icon"
            disabled={false}
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "view_details",
                rowData: row,
                isPT: true,
              }))
            }>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-eye-fill"
              viewBox="0 0 16 16">
              <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
              <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
            </svg>
          </button>
        </div>
      ),
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (_, row) => (
        <div className="actionButtonContainer">
          {/* <button
            type="button"
            className="actionBtn icon edit"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "edit_addon",
                rowData: row,
              }))
            }>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none">
              <path
                d="M3.62891 17.3603V20.3254C3.62891 20.5985 3.84349 20.8131 4.1166 20.8131H7.08175C7.20855 20.8131 7.33535 20.7643 7.42313 20.6668L18.0743 10.0254L14.4166 6.36775L3.77521 17.0091C3.67768 17.1067 3.62891 17.2237 3.62891 17.3603ZM20.9029 7.19682C20.9933 7.10658 21.065 6.9994 21.114 6.88141C21.1629 6.76341 21.1881 6.63692 21.1881 6.50918C21.1881 6.38143 21.1629 6.25495 21.114 6.13695C21.065 6.01896 20.9933 5.91177 20.9029 5.82154L18.6205 3.53915C18.5302 3.44873 18.4231 3.37699 18.3051 3.32805C18.1871 3.2791 18.0606 3.25391 17.9328 3.25391C17.8051 3.25391 17.6786 3.2791 17.5606 3.32805C17.4426 3.37699 17.3354 3.44873 17.2452 3.53915L15.4603 5.32409L19.1179 8.98176L20.9029 7.19682Z"
                fill="url(#paint0_linear_14023_4477)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_14023_4477"
                  x1="3.62891"
                  y1="11.6344"
                  x2="21.1881"
                  y2="11.6344"
                  gradientUnits="userSpaceOnUse">
                  <stop offset="0.0447915" stopColor="#B4000B" />
                  <stop offset="1" stopColor="#DD0000" />
                </linearGradient>
              </defs>
            </svg>
          </button> */}
          <button
            type="button"
            className="actionBtn icon delete"
            onClick={() => {
              const filters = { uid: row?.uid || "" };
              handleDelete(filters, row, "addon");
            }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill="none">
              <path
                d="M8.49846 4.3041H11.4978C11.4978 3.90637 11.3398 3.52492 11.0585 3.24369C10.7773 2.96245 10.3958 2.80445 9.99811 2.80445C9.60038 2.80445 9.21893 2.96245 8.9377 3.24369C8.65646 3.52492 8.49846 3.90637 8.49846 4.3041ZM7.4987 4.3041C7.4987 3.64121 7.76203 3.00548 8.23076 2.53675C8.69949 2.06802 9.33522 1.80469 9.99811 1.80469C10.661 1.80469 11.2967 2.06802 11.7655 2.53675C12.2342 3.00548 12.4975 3.64121 12.4975 4.3041H17.4963C17.6289 4.3041 17.7561 4.35676 17.8498 4.45051C17.9435 4.54425 17.9962 4.6714 17.9962 4.80398C17.9962 4.93655 17.9435 5.0637 17.8498 5.15745C17.7561 5.25119 17.6289 5.30386 17.4963 5.30386H16.4426L15.2489 15.6454C15.1645 16.3764 14.8143 17.0509 14.265 17.5405C13.7156 18.0302 13.0054 18.3007 12.2696 18.3008H7.72664C6.99077 18.3007 6.2806 18.0302 5.73125 17.5405C5.18191 17.0509 4.83173 16.3764 4.74735 15.6454L3.55363 5.30386H2.49988C2.3673 5.30386 2.24016 5.25119 2.14641 5.15745C2.05267 5.0637 2 4.93655 2 4.80398C2 4.6714 2.05267 4.54425 2.14641 4.45051C2.24016 4.35676 2.3673 4.3041 2.49988 4.3041H7.4987ZM8.99834 8.30315C8.99834 8.17057 8.94568 8.04343 8.85193 7.94968C8.75819 7.85593 8.63104 7.80327 8.49846 7.80327C8.36588 7.80327 8.23874 7.85593 8.14499 7.94968C8.05125 8.04343 7.99858 8.17057 7.99858 8.30315V14.3017C7.99858 14.4343 8.05125 14.5615 8.14499 14.6552C8.23874 14.7489 8.36588 14.8016 8.49846 14.8016C8.63104 14.8016 8.75819 14.7489 8.85193 14.6552C8.94568 14.5615 8.99834 14.4343 8.99834 14.3017V8.30315ZM11.4978 7.80327C11.3652 7.80327 11.238 7.85593 11.1443 7.94968C11.0505 8.04343 10.9979 8.17057 10.9979 8.30315V14.3017C10.9979 14.4343 11.0505 14.5615 11.1443 14.6552C11.238 14.7489 11.3652 14.8016 11.4978 14.8016C11.6303 14.8016 11.7575 14.7489 11.8512 14.6552C11.945 14.5615 11.9976 14.4343 11.9976 14.3017V8.30315C11.9976 8.17057 11.945 8.04343 11.8512 7.94968C11.7575 7.85593 11.6303 7.80327 11.4978 7.80327Z"
                fill="black"
              />
            </svg>
          </button>
          {/* <button
            type="button"
            className="actionBtn icon"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "map_addon",
                rowData: row,
              }))
            }>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-plus-circle-dotted"
              viewBox="0 0 16 16">
              <path d="M8 0q-.264 0-.523.017l.064.998a7 7 0 0 1 .918 0l.064-.998A8 8 0 0 0 8 0M6.44.152q-.52.104-1.012.27l.321.948q.43-.147.884-.237L6.44.153zm4.132.271a8 8 0 0 0-1.011-.27l-.194.98q.453.09.884.237zm1.873.925a8 8 0 0 0-.906-.524l-.443.896q.413.205.793.459zM4.46.824q-.471.233-.905.524l.556.83a7 7 0 0 1 .793-.458zM2.725 1.985q-.394.346-.74.74l.752.66q.303-.345.648-.648zm11.29.74a8 8 0 0 0-.74-.74l-.66.752q.346.303.648.648zm1.161 1.735a8 8 0 0 0-.524-.905l-.83.556q.254.38.458.793l.896-.443zM1.348 3.555q-.292.433-.524.906l.896.443q.205-.413.459-.793zM.423 5.428a8 8 0 0 0-.27 1.011l.98.194q.09-.453.237-.884zM15.848 6.44a8 8 0 0 0-.27-1.012l-.948.321q.147.43.237.884zM.017 7.477a8 8 0 0 0 0 1.046l.998-.064a7 7 0 0 1 0-.918zM16 8a8 8 0 0 0-.017-.523l-.998.064a7 7 0 0 1 0 .918l.998.064A8 8 0 0 0 16 8M.152 9.56q.104.52.27 1.012l.948-.321a7 7 0 0 1-.237-.884l-.98.194zm15.425 1.012q.168-.493.27-1.011l-.98-.194q-.09.453-.237.884zM.824 11.54a8 8 0 0 0 .524.905l.83-.556a7 7 0 0 1-.458-.793zm13.828.905q.292-.434.524-.906l-.896-.443q-.205.413-.459.793zm-12.667.83q.346.394.74.74l.66-.752a7 7 0 0 1-.648-.648zm11.29.74q.394-.346.74-.74l-.752-.66q-.302.346-.648.648zm-1.735 1.161q.471-.233.905-.524l-.556-.83a7 7 0 0 1-.793.458zm-7.985-.524q.434.292.906.524l.443-.896a7 7 0 0 1-.793-.459zm1.873.925q.493.168 1.011.27l.194-.98a7 7 0 0 1-.884-.237zm4.132.271a8 8 0 0 0 1.012-.27l-.321-.948a7 7 0 0 1-.884.237l.194.98zm-2.083.135a8 8 0 0 0 1.046 0l-.064-.998a7 7 0 0 1-.918 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3z" />
            </svg>
          </button> */}
        </div>
      ),
    },
  ];

  return (
    <div className="discount-payments-tabs bgTransParent">
      <Tabs onSelect={handleTabSelect}>
        <TabList>
          <Tab>Regular</Tab>
          {/* <Tab>PT (Addon)</Tab> */}
        </TabList>

        <TabPanel>
          {centralisedPlansLoading ? (
            <ReactVortoxSpinner />
          ) : (
            <div className="fullWidthFlexCenter overflowAuto separatedTable mt30">
              <PaymentLinkTable
                tableData={allDatas.allData}
                tableColumns={tbColumns}
                tablePagination={allDatas.pagination}
                isPage={isPage}
                setIsPage={(value) => setIsPage(value)}
                pageLimit={pageLimit}
                setPageLimit={setPageLimit}
              />
            </div>
          )}
        </TabPanel>
        {/* <TabPanel>
          {addonDraftsLoading ? (
            <ReactVortoxSpinner />
          ) : (
            <div className="fullWidthFlexCenter overflowAuto separatedTable">
              <PaymentLinkTable
                tableData={addonDatas.allData}
                tableColumns={addonTbColumns}
                tablePagination={addonDatas.pagination}
                isPage={isPage}
                setIsPage={(value) => setIsPage(value)}
                pageLimit={pageLimit}
                setPageLimit={setPageLimit}
              />
            </div>
          )}
        </TabPanel> */}
      </Tabs>
    </div>
  );
};

export default CentralisedTabs;
